import {FormControl, FormField} from 'platform/components';
import {HStack, Icon, Text, VStack} from 'platform/foundation';

import {Path} from 'react-hook-form';

import {isNil} from 'ramda';

import {GetSalesPlatformsApiRes} from '@dms/api/sales';
import i18n from '@dms/i18n';

import {suffixTestId, TestIdProps} from 'shared/web';

import {KNOWN_PLATFORM_TITLE_LIMITS} from '../constants/knownPlatformTitleLimits';
import {LOCALIZED_TITLE_MAX_LENGTH} from '../constants/localizedTitleMaxLength';
import {GeneralSettingsFormValues} from '../types/GeneralSettingsFormValues';

interface TitleFormFieldProps extends TestIdProps {
  vehicleId: string;
  control: FormControl<GeneralSettingsFormValues>;
  name: Path<GeneralSettingsFormValues>;
  label?: string;
  isDisabled?: boolean;
  platforms: GetSalesPlatformsApiRes | undefined;
}

export function TitleFormField(props: TitleFormFieldProps) {
  const enabledPlatforms = (props.platforms ?? []).filter((p) => p.platform.enabled);

  return (
    <VStack spacing={1}>
      <FormField
        control={props.control}
        label={props.label ?? i18n.t('page.advertisement.labels.localizedTitle')}
        name={props.name}
        type="text"
        isDisabled={props.isDisabled}
        maxLength={LOCALIZED_TITLE_MAX_LENGTH}
        isCounterVisible
        data-testid={suffixTestId('localizedTitle', props)}
      />
      <HStack spacing={1} align="center">
        {enabledPlatforms.map((p) => {
          const limit = KNOWN_PLATFORM_TITLE_LIMITS[p.platform.code];
          if (isNil(limit)) {
            return null;
          }

          return (
            <HStack key={p.platform.code} spacing={1} align="center">
              <Icon size={5} value="action/check_circle" color="severity.success" />
              <Text size="xSmall" color="secondary">
                {`${p.platform.title}: ${limit}`}
              </Text>
            </HStack>
          );
        })}
      </HStack>
    </VStack>
  );
}
